import { ReturnsAndClaimsPermissions } from "@redotech/account-common/permissions";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import {
  productDetailsBreadcrumb,
  returnsClaimsAnalyticsBreadcrumb,
} from "./breadcrumbs";

export const returnsClaimsAnalyticsRoutes: PermissionedRouteObject[] = [
  {
    index: true,
    handle: {
      breadcrumb: returnsClaimsAnalyticsBreadcrumb,
      permission: [ReturnsAndClaimsPermissions.VIEW_RETURN_AND_CLAIM_ANALYTICS],
    },
    async lazy() {
      const { ReturnClaimAnalytics } = await import("./return-claim-analytics");
      return { Component: ReturnClaimAnalytics };
    },
  },
  {
    path: "products/:productId",
    handle: {
      breadcrumb: productDetailsBreadcrumb,
      permission: [ReturnsAndClaimsPermissions.VIEW_RETURN_AND_CLAIM_ANALYTICS],
    },
    async lazy() {
      const { ProductDetails } = await import("./product/product-details");
      return { Component: ProductDetails };
    },
  },
];
